import { Component, Input, TemplateRef, ViewChild } from '@angular/core';

@Component({
  selector: 'm-sidebar-menu-item',
  template: `
    <ng-template #itemTemplate>
      <ng-content></ng-content>
    </ng-template>
  `
})
export class MSidebarMenuItemComponent {
  @ViewChild('itemTemplate', { static: true }) itemTemplate!: TemplateRef<void>;
  @Input() mTabIcon: string = '';
  @Input() mTabTitle: string = '';
  @Input() mHeaderRef: TemplateRef<void> | null = null;

  get content(): TemplateRef<void> {
    return this.itemTemplate;
  }

  get header(): TemplateRef<void> | null {
    return this.mHeaderRef;
  }
}
